import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  paper: {
    border: '0 !important',
  },
  content: {
    padding: 0,
  },
  contentText: {
    padding: '16px 24px',
    marginBottom: 0,
    '& p:not(last-of-type)': {
      marginBottom: 16,
    },
  },
  actions: {
    justifyContent: 'space-between',
    '& div': {
      display: 'flex',
      gap: 8,
    },
  },
}));

export default useStyles;
